<!-- LOADING -->
<app-loading [hidden]="!loading"></app-loading>

<!-- CONTEÚDO -->
<ng-container *ngIf="viewModules$ | async as vm">
<div *ngIf="!loading && anamnese" class="flex flex-col h-[calc(100dvh-120px)] print:h-auto">

    <!-- HEADER INTERNO (esconde na impressão) -->
    <div class="bg-white rounded-lg border border-gray-200 p-4 mb-6 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 flex-shrink-0 print-hide">
        <div class="flex items-center gap-4 min-w-0">
            <div class="flex flex-col min-w-0">
                <span class="text-lg font-semibold text-westetics-neutral-950 truncate">{{ vm.moduleName === 'PACIENTES' ? 'Ficha de Anamnese' : 'Ficha do Formulário' }}</span>
                <span class="text-sm text-westetics-neutral-600 truncate">
                    {{ patient?.full_name || 'Paciente' }} • Enviado em {{ formatDateTime(anamnese.created_at) }}
                </span>
            </div>
        </div>
        <div class="flex flex-col sm:flex-row gap-2 sm:gap-3 w-full sm:w-auto">
            <button 
                (click)="printAnamnese()"
                class="px-3 sm:px-4 py-2 text-sm font-medium rounded-lg transition-colors flex items-center justify-center gap-2 text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 border"
            >
                <fa-icon [icon]="faPrint"></fa-icon>
                Imprimir
            </button>
            <button 
                *ngIf="anamnese.is_answered && vm.moduleName === 'PACIENTES'"
                (click)="generateDocs()"
                class="px-3 sm:px-4 py-2 text-sm font-medium bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white rounded-lg transition-colors flex items-center justify-center gap-2"
            >
                <fa-icon [icon]="faFileAlt"></fa-icon>
                <span class="sm:hidden">Gerar com Anamnese</span>
                <span class="hidden sm:inline">Gerar Documentos com Anamnese</span>
            </button>
        </div>
    </div>

    <!-- CONTEÚDO SCROLLÁVEL (imprime normalmente) -->
    <div class="flex-1 overflow-y-auto print:overflow-visible" id="print-content">
        <div class="max-w-4xl print:max-w-full">

            <!-- TÍTULO PARA IMPRESSÃO (só aparece na impressão) -->
            <div class="hidden print:block mb-6">
                <h1 class="text-xl font-bold text-gray-900">{{ vm.moduleName === 'PACIENTES' ? 'Ficha de Anamnese' : 'Ficha do Formulário' }}</h1>
                <p class="text-sm text-gray-600">{{ patient?.full_name || 'Paciente' }} • Enviado em {{ formatDateTime(anamnese.created_at) }}</p>
            </div>

            <!-- STATUS BADGE -->
            <div class="flex items-center gap-3 mb-6 flex-wrap">
                <span class="text-sm font-medium text-gray-700">Status:</span>
                <span 
                    class="px-4 py-1.5 text-sm font-medium rounded-full flex items-center gap-2"
                    [ngClass]="anamnese.is_answered ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'"
                >
                    <fa-icon [icon]="anamnese.is_answered ? faCheck : faClock" class="text-xs"></fa-icon>
                    {{ anamnese.is_answered ? 'Preenchido' : 'Aguardando Resposta' }}
                </span>
                <span *ngIf="patient?.is_model_patient" class="px-4 py-1.5 text-sm font-semibold rounded-full bg-yellow-100 text-yellow-800">
                    Paciente modelo
                </span>
            </div>

            <!-- DADOS DO PACIENTE -->
            <div class="bg-white rounded-lg border border-gray-200 p-4 sm:p-6 mb-6">
                <h3 class="text-base font-semibold text-westetics-neutral-950 mb-4 pb-3 border-b">
                    Dados do {{ vm.moduleNameInSingular }}
                </h3>
                <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4 md:gap-6">
                    <div>
                        <p class="text-xs text-gray-500 uppercase mb-1">Nome Completo</p>
                        <p class="text-sm font-medium text-gray-800">{{ patient?.full_name || '-' }}</p>
                    </div>
                    <div class="min-w-0">
                        <p class="text-xs text-gray-500 uppercase mb-1">Email</p>
                        <p class="text-sm font-medium text-gray-800 break-all">{{ patient?.email || '-' }}</p>
                    </div>
                    <div>
                        <p class="text-xs text-gray-500 uppercase mb-1">Telefone</p>
                        <p class="text-sm font-medium text-gray-800">{{ patient?.phone || '-' }}</p>
                    </div>
                    <div *ngIf="patient?.birth_date">
                        <p class="text-xs text-gray-500 uppercase mb-1">Data de Nascimento</p>
                        <p class="text-sm font-medium text-gray-800">{{ formatDate(patient?.birth_date) }}</p>
                    </div>
                    <div *ngIf="patientAge !== null">
                        <p class="text-xs text-gray-500 uppercase mb-1">Idade</p>
                        <p class="text-sm font-medium text-gray-800">{{ patientAge }} anos</p>
                    </div>
                    <div *ngIf="patient?.cpf">
                        <p class="text-xs text-gray-500 uppercase mb-1">CPF</p>
                        <p class="text-sm font-medium text-gray-800">{{ patient?.cpf }}</p>
                    </div>
                    <div *ngIf="patient?.rg">
                        <p class="text-xs text-gray-500 uppercase mb-1">RG</p>
                        <p class="text-sm font-medium text-gray-800">{{ patient?.rg }}</p>
                    </div>
                    <div *ngIf="patient?.marital_status">
                        <p class="text-xs text-gray-500 uppercase mb-1">Estado Civil</p>
                        <p class="text-sm font-medium text-gray-800">{{ patient?.marital_status }}</p>
                    </div>
                    <div *ngIf="patient?.profession">
                        <p class="text-xs text-gray-500 uppercase mb-1">Profissão</p>
                        <p class="text-sm font-medium text-gray-800">{{ patient?.profession }}</p>
                    </div>
                    <div *ngIf="patient?.instagram_account">
                        <p class="text-xs text-gray-500 uppercase mb-1">Instagram</p>
                        <p class="text-sm font-medium text-gray-800">{{ patient?.instagram_account }}</p>
                    </div>
                </div>

                <!-- Dados do Responsável Legal (exibido apenas para menores de idade) -->
                <div *ngIf="isMinor && (patient?.guardian_name || patient?.guardian_cpf || patient?.guardian_phone)" class="mt-6 pt-4 border-t">
                    <h4 class="text-sm font-semibold text-gray-700 mb-3">Dados do Responsável Legal</h4>
                    <p class="text-xs text-gray-500 mb-3">Paciente menor de idade</p>
                    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4">
                        <div *ngIf="patient?.guardian_name">
                            <p class="text-xs text-gray-500 uppercase mb-1">Nome do Responsável</p>
                            <p class="text-sm text-gray-800">{{ patient?.guardian_name }}</p>
                        </div>
                        <div *ngIf="patient?.guardian_cpf">
                            <p class="text-xs text-gray-500 uppercase mb-1">CPF do Responsável</p>
                            <p class="text-sm text-gray-800">{{ patient?.guardian_cpf }}</p>
                        </div>
                        <div *ngIf="patient?.guardian_phone">
                            <p class="text-xs text-gray-500 uppercase mb-1">Telefone do Responsável</p>
                            <p class="text-sm text-gray-800">{{ patient?.guardian_phone }}</p>
                        </div>
                    </div>
                </div>

                <!-- Endereço -->
                <div *ngIf="patient?.address" class="mt-6 pt-4 border-t">
                    <h4 class="text-sm font-semibold text-gray-700 mb-3">Endereço</h4>
                    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4">
                        <div *ngIf="patient?.address?.street">
                            <p class="text-xs text-gray-500 uppercase mb-1">Rua</p>
                            <p class="text-sm text-gray-800">{{ patient?.address?.street }}</p>
                        </div>
                        <div *ngIf="patient?.address?.number">
                            <p class="text-xs text-gray-500 uppercase mb-1">Número</p>
                            <p class="text-sm text-gray-800">{{ patient?.address?.number }}</p>
                        </div>
                        <div *ngIf="patient?.address?.complement">
                            <p class="text-xs text-gray-500 uppercase mb-1">Complemento</p>
                            <p class="text-sm text-gray-800">{{ patient?.address?.complement }}</p>
                        </div>
                        <div *ngIf="patient?.address?.neighborhood">
                            <p class="text-xs text-gray-500 uppercase mb-1">Bairro</p>
                            <p class="text-sm text-gray-800">{{ patient?.address?.neighborhood }}</p>
                        </div>
                        <div *ngIf="patient?.address?.city">
                            <p class="text-xs text-gray-500 uppercase mb-1">Cidade</p>
                            <p class="text-sm text-gray-800">{{ patient?.address?.city }}</p>
                        </div>
                        <div *ngIf="patient?.address?.state">
                            <p class="text-xs text-gray-500 uppercase mb-1">Estado</p>
                            <p class="text-sm text-gray-800">{{ patient?.address?.state }}</p>
                        </div>
                        <div *ngIf="patient?.address?.country">
                            <p class="text-xs text-gray-500 uppercase mb-1">País</p>
                            <p class="text-sm text-gray-800">{{ patient?.address?.country }}</p>
                        </div>
                        <div *ngIf="patient?.address?.zip_code">
                            <p class="text-xs text-gray-500 uppercase mb-1">CEP</p>
                            <p class="text-sm text-gray-800">{{ patient?.address?.zip_code }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- SEÇÕES DE PERGUNTAS E RESPOSTAS -->
            <div *ngIf="anamnese.is_answered && sections.length > 0" class="space-y-4 mb-6">
                <div *ngFor="let section of sections" class="bg-white rounded-lg border border-gray-200 overflow-hidden">
                    <!-- Header da Seção -->
                    <div class="bg-westetics-purple-100 px-6 py-4 border-b border-westetics-purple-200">
                        <h3 class="text-base font-semibold text-westetics-purple-800">{{ section.name }}</h3>
                    </div>

                    <!-- Perguntas da Seção -->
                    <div class="p-6 space-y-6">
                        <div *ngFor="let question of section.questions; let last = last" 
                             class="pb-5"
                             [ngClass]="{'border-b border-gray-100': !last}">
                            
                            <!-- Pergunta -->
                            <p class="text-sm font-medium text-westetics-neutral-950 mb-3">
                                {{ question.label }}
                                <span *ngIf="question.is_required" class="text-red-500 ml-1">*</span>
                            </p>

                            <!-- Texto de ajuda -->
                            <p *ngIf="question.help_text" class="text-xs text-gray-500 italic mb-3">
                                {{ question.help_text }}
                            </p>

                            <!-- Resposta -->
                            <div class="pl-4 border-l-4 border-westetics-purple-300 bg-gray-50 rounded-r-lg py-3 px-4">
                                <p class="text-sm text-gray-700" [innerHTML]="getAnswerDisplay(question)"></p>
                                
                                <!-- Observação -->
                                <p *ngIf="question.observation" class="text-xs text-gray-500 italic mt-2 pt-2 border-t border-gray-200">
                                    <span class="font-medium text-gray-600">Observação:</span> {{ question.observation }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- MENSAGEM SE NÃO FOI RESPONDIDA -->
            <div *ngIf="!anamnese.is_answered" class="bg-white rounded-lg border border-gray-200 p-12 text-center mb-6">
                <div class="inline-flex items-center justify-center w-16 h-16 bg-yellow-100 rounded-full mb-4">
                    <fa-icon [icon]="faWarning" class="text-2xl text-yellow-600"></fa-icon>
                </div>
                <h3 class="text-lg font-semibold text-gray-700 mb-2">Aguardando Resposta</h3>
                <p class="text-sm text-gray-500 mb-4">Esta anamnese ainda não foi preenchida pelo {{ vm.moduleNameInSingular | lowercase }}.</p>
                <p class="text-xs text-gray-400">
                    Link enviado para: <span class="font-medium">{{ patient?.email || '-' }}</span>
                </p>
                <div *ngIf="anamnese.url_link" class="mt-4">
                    <p class="text-xs text-gray-400 mb-2">Link da anamnese:</p>
                    <a 
                        [href]="anamnese.url_link" 
                        target="_blank"
                        class="text-sm text-westetics-purple-600 hover:text-westetics-purple-800 underline break-all"
                    >
                        {{ anamnese.url_link }}
                    </a>
                </div>
            </div>

            <!-- MENSAGEM SE NÃO HÁ SEÇÕES (apenas para PACIENTES que têm anamnese com perguntas) -->
            <div *ngIf="anamnese.is_answered && sections.length === 0 && vm.moduleName === 'PACIENTES'" class="bg-white rounded-lg border border-gray-200 p-12 text-center mb-6">
                <p class="text-sm text-gray-500">Não foi possível carregar as perguntas desta anamnese.</p>
            </div>

        </div>
    </div>

</div>
</ng-container>
